import { get } from "../methods";
function getUacCheck(headers = {}, baseURL) {
  return get({
    url: "api/uac/check",
    payload: {
      action: "get_config"
    },
    headers,
    baseURL
  });
}
export {
  getUacCheck as default
};
